import defaultLocale from "../../locale/en-US/index.js";
export default defaultLocale;


//////////////////
// WEBPACK FOOTER
// ./~/date-fns/esm/_lib/defaultLocale/index.js
// module id = ./node_modules/date-fns/esm/_lib/defaultLocale/index.js
// module chunks = 1